import { motion } from 'framer-motion';
import { FiInstagram, FiMail } from 'react-icons/fi';

import type { ContactMethod } from '../types/contactTypes';
import ContactInfoCard from './contactInfoCard';

const contactMethods: ContactMethod[] = [
  {
    icon: FiMail,
    label: 'EMAIL',
    value: 'info@konnectbetter.com',
    subtext:
      'have questions? want to learn more? just reach out. we reply within 1-2 business days.',
    href: 'mailto:info@konnectbetter.com',
  },
  {
    icon: FiInstagram,
    label: 'INSTAGRAM',
    value: '@konnectbetter',
    subtext:
      "follow us for real time updates and send us a message, we'd love to connect!",
    href: 'https://www.instagram.com/konnectbetter/',
    external: true,
  },
];

export default function GetInTouchSection() {
  return (
    <section className="section bg-surface dark:bg-panel/95">
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="container-custom"
      >
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div>
            <span className="text-theme-secondary text-sm tracking-wider uppercase block mb-4">
              — GET IN TOUCH
            </span>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-primary dark:text-theme-primary mb-6">
              we'd love to
              <br />
              <span className="text-secondary italic">hear from you</span>
            </h1>
            <p className="text-lg text-theme-secondary">
              Whether you have questions about any of our tools, resources
              community, or simply want to say hello, we'd love to connect. our
              team is here to help support you and your journey towards stronger
              relationships.
            </p>
          </div>

          <div className="space-y-4">
            {contactMethods.map((method) => (
              <ContactInfoCard key={method.label} {...method} />
            ))}
          </div>
        </div>
      </motion.div>
    </section>
  );
}
